import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    let initialized = false;
    const initPixel = () => {
      if (initialized) return;
      initialized = true;
      // Load the Meta Pixel script asynchronously
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
      }
      window.fbq('init', '1432290168369362');
      window.fbq('track', 'PageView');
    };
    // Defer pixel until browser is idle (after LCP) for better performance
    const idleId = (window as any).requestIdleCallback ? (window as any).requestIdleCallback(initPixel, {
      timeout: 3500
    }) : setTimeout(initPixel, 2500);
    return () => {
      if ((window as any).cancelIdleCallback && typeof idleId === 'number') {
        ;
        (window as any).cancelIdleCallback(idleId);
      } else {
        clearTimeout(idleId as any);
      }
    };
  }, []);
  return null;
}